import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment'
import SelectForm from './../components/Complements/SelectForm';
import Title from './../components/Complements/Title';
import DateFnsUtils from '@date-io/date-fns';
import "moment/locale/es";
import esLocale from "date-fns/locale/es";
import { connect } from 'react-redux';
import { getCodes } from "./../actions/codes";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
  } from '@material-ui/pickers';
import { Grid, CircularProgress, Icon, Fab, FormControl, InputLabel, Select, MenuItem, Button } from '@material-ui/core';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import './../components/Codes/style/tableresponsive.css';
import Pagination from '@material-ui/lab/Pagination';
import Alert from '@material-ui/lab/Alert';
import Dashboard from '../components/Menu/Dashboard';
import { history } from '../helpers/history';
import LoadingScreen from '../components/Complements/LoadingScreen';
import StandardDialog from '../components/Complements/StandardDialog';
import Voucher from '../components/Transfers/Voucher';
import { urlVoucher } from '../services/urls';
import { sendEmailWithVoucher } from "../actions/sendEmailWithVoucher";
import { findTransferCore } from "../actions/transferscore";
import { sendMobile } from '../functions/mobile';
import { feathersCreateData } from '../services';
import { isMobile } from 'react-device-detect';
import { handleDownloadMovil, handleDownloadWeb } from '../functions/handle-download';

const VoucherCreditsPayContainer = props => {
    const { classes, balances, user, handleOpenSnack } = props
    const [ codespaginate, setCodesPaginate ] = useState([])
    const [ page, setPage ] = useState(1)
    const [ count, setCount ] = useState(1)
    const [ loading, setLoading ] = useState(false)
    const [ dialog, setDialog ] = useState({
        open: false,
        title: '',
        children: <div></div>
    })
    const [ dateStart, setDateStart ] = useState(new Date(moment().startOf('month')))
    const [ dateEnd, setDateEnd ] = useState(new Date(moment().endOf('month')))
    const [ dateValue, setDateValue ] = useState(JSON.stringify({month: moment().month(), year: moment().year()}))
    const [accountSelected, setAccountSelected ] = useState(balances[0])


    const mount = () => {
        const unmount = () => {
            moment.locale('es-es')

            handleGetDataMovementsBySecuencialAccount(0, dateStart, dateEnd, 1, accountSelected.Codigo)
        }
        return unmount()
    }

    const handleGetDataMovementsBySecuencialAccount = (rows, valuedateStart, valuedateEnd, numberpage, secuencial) => {

        setLoading(true)

        findTransferCore({
            $limit: 10,
            $skip : rows,
            type : 20,
            state : true,
            name: secuencial,
            createdAt: {
                $lte: valuedateEnd,
                $gte: valuedateStart
            }
        }).payload.then(
            response => {

                //console.log(response)

                const { data, total } = response

                convertJsonToData(data, total, numberpage)

                setLoading(false)
            }
        ).catch(
            error => {
                //console.log(error)
                setLoading(false)
            }
        )
    }

    const convertJsonToData = (data, total, numberpage) => {
        let resul = [];

        data.forEach(row => {
            
            try {
                
                let transfertjson = JSON.parse(row.response);
                //console.log(transfertjson)
                (transfertjson.NumeroPrestamo) && resul.push(transfertjson);

            } catch (error) {
                //console.log(error)
            }
        
        })

        // console.log("TODOS LOS MOVIMIENTOS: ", resul)

        setCodesPaginate(resul)

        getDataViewTable(total, numberpage);
    }

    useEffect(mount, []) 

    const handleDateStart = (date) => {
        setDateStart(date)
    }

    const handleDateEnd = (date) => {
        setDateEnd(date)
    }

    const onChangePaginationCodes = (e, numberpage) => {
        handleGetDataMovementsBySecuencialAccount((numberpage - 1)*10, dateStart, dateEnd, numberpage, accountSelected.Codigo);
    }

    const handleSubmit = (val) => {
        // console.log(val)
    }

    const getDataViewTable = (total, numberpage) => {
        
        let contador = parseInt((total / 10).toString());
        let residuo = total % 10;

        if(residuo > 0){
            contador++;
        }

        setCount(contador)
        setPage(numberpage)
    }

    const handleAccountFind = (value) => {

        setAccountSelected(value)
        //setAllCodes([])
        //console.log(allcodes)
        handleGetDataMovementsBySecuencialAccount(0, dateStart, dateEnd, 1, value.Codigo)
        
    }

    //handle
    const handleSelectCode = (val) => {
        // console.log(val)
        setDateValue(val)
        setLoading(true)
        if (val === 'Todos los movimientos') {
            setLoading(false)
            
        } else {
            let obj = JSON.parse(val)
            // console.log('busca mes', obj.month)

                let selectMonth = new Date(obj.year, obj.month, 1)
                
                setDateStart(moment(selectMonth).startOf('month'))
                setDateEnd(moment(selectMonth).endOf('month'))
                //filterCodesByDate(dateStart, dateEnd, allcodes)
                setDateValue(val)
                setLoading(false)
                handleGetDataMovementsBySecuencialAccount(0, new Date(moment(selectMonth).startOf('month')), new Date(moment(selectMonth).endOf('month')), 1, accountSelected.Codigo)
        }
        
    }
    const handleFindRange = () => {
        
        handleGetDataMovementsBySecuencialAccount(0, dateStart, dateEnd, 1, accountSelected.Codigo)
        
    }

    const handleViewVoucher = (row) => {
        let MontoPrestamo = (row.MontoPrestamo) ? "$ "+row.MontoPrestamo : "";
        
        setDialog({open: true, title: 'Comprobante',
                    children:   <Voucher
                                    amount ={row.Valor}
                                    titleheader = { "Valor cancelado" }
                                    title = { "Comprobante" }
                                    textButtonCancel = { "Cancelar" }
                                    handleCancel = { handleCLoseDialog }
                                    databodyone = {
                                                [
                                                    {
                                                        title : "Socio:",
                                                        value : user.Nombres + " " + user.Apellidos,
                                                        order : 1
                                                    },
                                                    {
                                                        title : "C.I.:",
                                                        value : user.Identificacion,
                                                        order : 2
                                                    },
                                                    {
                                                        title : "Nro. de cuenta:",
                                                        value : accountSelected.Codigo,
                                                        order : 3
                                                    },
                                                    {
                                                        title : "Nro. de préstamo:",
                                                        value : row.NumeroPrestamo,
                                                        order : 4
                                                    },
                                                    {
                                                        title : "Valor inicial:",
                                                        value : MontoPrestamo,
                                                        order : 5
                                                    },
                                                    {
                                                        title : "Fecha de pago:",
                                                        value : moment(row.Fecha).format("YYYY/MM/DD"),
                                                        order : 6
                                                    },
                                                    {
                                                        title : "No. de transacción:",
                                                        value : row.NumeroDocumento,
                                                        order : 7
                                                    }
                                                ]
                                            }
                                    
                                    handleDownloadVoucher = { () => { 
                                        feathersCreateData('voucher-document', { name:accountSelected.Codigo, document: row.NumeroDocumento, name_voucher: row.name_voucher})().then(res => {
                                            if (res.error) {
                                                handleOpenSnack(res.message, 'error')
                                            } else {
                                                // window.open(urlVoucher+res.voucher+".pdf", '_blank');
                                                if (isMobile) {
                                                    handleDownloadMovil(urlVoucher, res.voucher)
                                                } else {
                                                    // window.open(urlCertificates+nameFile+".pdf", '_blank');
                                                    handleDownloadWeb(urlVoucher, res.voucher)
                                                }
                                            }
                                        }).catch(err => handleOpenSnack('No se ha encontrado el documento', 'error') )
                                    }}
                                    handleDownloadDevice = { () => {
                                        try {
                                            feathersCreateData('voucher-document', { name:accountSelected.Codigo, document: row.NumeroDocumento, name_voucher: row.name_voucher})().then(res => {
                                                if (res.error) {
                                                    handleOpenSnack(res.message, 'error')
                                                } else {
                                                    let namefile = res.name_voucher
                                                    let send = {
                                                        type: 'action',
                                                        action: 'export_voucher',
                                                        data: urlVoucher+namefile+".pdf",
                                                        nameFile: namefile,
                                                        extension: 'pdf',
                                                        messageSend: 'Pago de creditos'
                                                    }
                                                    sendMobile(JSON.stringify(send))
                                                }
                                            }).catch(err => handleOpenSnack('No se ha encontrado el documento', 'error') )
                                            
                                        } catch (error) {
                                            //console.log(error)
                                        }
                                    }}
                                    
                                />
                                })
        
    }
    const handleCLoseDialog  = () => {
        setDialog({...dialog, open: false})
    }
    const renderTableMovements = () => {
        if (loading) {
            return <CircularProgress />
        } else {
            if (codespaginate.length > 0) {
                return  <div className = { "container" }>
                        <Grid item xs={12} md={12} lg = {12}>
                            <Table className = {"table"}>
                                <Thead>
                                    <Tr>
                                        <Th>Fecha</Th>
                                        <Th># Préstamo</Th>
                                        <Th>Institución</Th>
                                        <Th className = { "colunmvalue"}>Monto</Th>
                                        <Th className = { "colunmvalue"}>Saldo</Th>
                                        <Th>Comprobante</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    { 
                                        
                                        codespaginate.map(row => (
                                            <Tr key={`${row.NumeroDocumento}-${row.Fecha}`}>
                                                <Td>{moment(row.Fecha).format("YYYY-MM-DD")}</Td>
                                                <Td>{row.NumeroPrestamo}</Td>
                                                <Td>{'COOPERATIVA CAJA.'}</Td>
                                                <Td>$ { row.Valor }</Td>
                                                <Td>$ { row.SaldoPrestamo }</Td>
                                                <Td><Button variant="contained"
                                                        onClick = {() => handleViewVoucher(row)}
                                                        fullWidth
                                                        style= {{
                                                            fontSize: '0.6rem',
                                                            color: '#1a1919',
                                                            borderLeft: '3px solid rgba(255, 198, 0)',
                                                            backgroundColor: "white",
                                                            borderRadius: '0px',
                                                            fontFamily: 'Ubuntu',
                                                            fontWeight: 'bold'
                                                        }}>Ver</Button></Td>
                                            </Tr>
                                        ))
                                        
                                    }
                                    
                                </Tbody>
                            </Table>
                            <Pagination 
                                count = { count } 
                                color = "primary" 
                                page = { page }
                                onChange = { onChangePaginationCodes }
                            />
                        </Grid>
                        </div>
            } else {
                return <Alert severity="info">No se han encontrado pagos de préstamos en el mes seleccionado.</Alert>
            }
        }
    }
    const renderBody = () => {
        return  <div>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={8} lg = {8} sm = {12}>
                            <Title>Detalle de pago de préstamos de la Cuenta </Title>
                        </Grid>
                        <Grid item xs={12} md={4} lg = {4} sm = {12}>
                            
                        </Grid>
                    </Grid>
                    <SelectForm
                        name = { 'Período' }
                        label = { 'Seleccione período '}
                        // data = { [{ id: '1', name: 'data'}] }
                        classes = { classes }
                        dateValue = { dateValue }
                        onSelected = { (val) => handleSelectCode(val)}
                        onSubmit={ handleSubmit }
                    ></SelectForm>
                    <br></br>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Grid container justify="center" spacing={3}  alignItems="flex-end">
                                <Grid item md={4} sm={12} xs={12}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                        <KeyboardDatePicker
                                            autoOk
                                            variant="inline"
                                            format="dd/MM/yyyy"
                                            margin="normal"
                                            id="date-start"
                                            label="Fecha de inicio"
                                            value={dateStart}
                                            onChange={handleDateStart}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item md={4} sm={12} xs={12}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                        <KeyboardDatePicker
                                            autoOk
                                            variant="inline"
                                            format="dd/MM/yyyy"
                                            margin="normal"
                                            id="date-end"
                                            label="Fecha de fin"
                                            value={dateEnd}
                                            onChange={handleDateEnd}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item md={2} sm={6} xs={6}>
                                    <Fab color="primary" style= {{ backgroundColor:'#00a0af'}} aria-label="add" onClick = { handleFindRange } >
                                        <Icon>search</Icon>
                                    </Fab>
                                </Grid>
                                <Grid item md={2} sm={6} xs={6}>
                                    <Fab color="primary" aria-label="add" onClick = { () => history.push('/')} >
                                        <Icon>close</Icon>
                                    </Fab>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <br/> <br/>
                    <Grid container spacing={3} justify="center" alignItems="center">
                        {
                            renderTableMovements()
                        }
                    </Grid>
                </div>
    }
    const renderHeader = () => {
        return  <div>
                    <FormControl variant="outlined" style={{minWidth: '100%'}}>
                        <InputLabel id="demo-simple-select-outlined-label">Seleccione una Cuenta</InputLabel>
                        <Select
                        label="Seleccione una Cuenta"
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        defaultValue={balances[0]}
                        onChange={(e) => handleAccountFind(e.target.value) }
                        >
                            {
                                balances.map(option => {
                                return <MenuItem key={option.Codigo} value={option}>{`${option.Codigo} - ${option.Tipo}`}</MenuItem>
                                })
                            }
                        </Select>
                    </FormControl>
                </div>
    }
    return (
        <div>
            <Dashboard
                title= "Dashboard"
                body = { renderBody() }
                info = { renderHeader()}
                multiple = { true }
                panel = {2}
            />
            <LoadingScreen open={loading} />
            <StandardDialog 
                handleClose = {handleCLoseDialog}
                open = {dialog.open}
                title = {dialog.title}>
                   { dialog.children }
            </StandardDialog> 
        </div>
    );
};

VoucherCreditsPayContainer.propTypes = {
    balances: PropTypes.array.isRequired,
};

export default connect(null , { getCodes, sendEmailWithVoucher, findTransferCore })(VoucherCreditsPayContainer);

//export default VoucherCreditsPayContainer;